<template>
  <div class="form-inline">
    <label>
      {{ this.$t("common.yes") }}
      <input v-model="val" type="radio" :value="true" class="ml-1" />
    </label>

    <label class="ml-3">
      {{ this.$t("common.no") }}
      <input v-model="val" type="radio" :value="false" class="ml-1" />
    </label>
  </div>
</template>

<script>
import OperatorSelect from "./OperatorSelect";
export default {
  props: ["value"],
  components: { OperatorSelect },
  computed: {
    val: {
      get() {
        return this.value ? this.value.value : undefined;
      },
      set(value) {
        this.$emit("input", {
          ...this.value,
          value,
        });
      },
    },
  },
  methods: {},
};
</script>
